<template>
  <div>
    <HistoryBaseDesign
      :pageTitle="pageTitle"
      :searchHeaderInfo="searchHeaderInfo"
      @changeInvalid="
        initPager()
        ini()
      "
      @changeProductName="
        initPager()
        ini()
      "
    >
      <template #searchDetailArea>
        <div class="px-9 py-7" style="display: flex">
          <div style="width: 360px" class="mr-9">
            <InputFormNew
              v-model="searchDetailInfo.line1"
              :detail="searchDetail.line1"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
          <div style="width: 200px" class="mr-9 mt-12">
            <InputFormNew
              v-model="searchDetailInfo.line2"
              :detail="searchDetail.line2"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="4"
              :contentsCols="8"
              @offSearchHeaderInfoInvalidData="offSearchHeaderInfoInvalidData"
            >
            </InputFormNew>
          </div>
          <div style="width: 450px" class="mr-9 mt-12">
            <InputFormNew
              v-model="searchDetailInfo.line3"
              :detail="
                !authority.isOutsideStaff
                  ? searchDetail.line3
                  : searchDetail.line3_OutsideStaff
              "
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
          <div v-if="isMakerAccount()" class="mr-9 mt-12" style="width: 200px">
            <InputFormNew
              v-model="searchDetailInfo.line4"
              :detail="searchDetail.line4"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="4"
              :contentsCols="8"
            >
            </InputFormNew>
          </div>
        </div>
      </template>
      <template #historyList>
        <HistoryList
          :summary="summary"
          :historyList="historyList"
          :headers="headers"
          :itemKey="tableKey"
          :productListHeaders="productListHeaders"
          :pagerKey="pagerKey"
          @rowDialogMethodCommon="rowDialogMethodCommon"
          @pageMove="ini"
          ref="historyListComponent"
          :saleDate="searchDetailInfo.line1.saleDate"
        >
        </HistoryList>
      </template>
    </HistoryBaseDesign>

    <ShipDialog
      v-model="dialogs.ship"
      :title="$t('sale.sale_ship-operate')"
      :recItems="dialogs.ship.rowItems"
      :pageInfoData="dialogs.ship.pageInfoData"
      @complete="completeShip"
      :dialogReload="dialogs.ship.dialogReload"
    >
      <template #historyList="{ item }">
        <HistoryList
          :isOperation="true"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
          @dialogReload="dialogReload('ship')"
        >
        </HistoryList>
      </template>
    </ShipDialog>

    <SalesDetailDialog
      v-model="dialogs.salesDetail"
      :title="$t('common.input_sale-details')"
      width="80%"
      :recItems="dialogs.salesDetail.rowItems"
      :pageInfoData="dialogs.salesDetail.pageInfoData"
      @complete="completesalesDetail"
    >
      <template #shipHistoryList="{ item }">
        <HistoryList
          :isOperation="true"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
      <template #refundHistoryList="{ item }">
        <HistoryList
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
          :isFooter="true"
        >
        </HistoryList>
      </template>
      <template #changeHistoryList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
          :isFooter="true"
          :isChangeHistory="true"
        >
        </HistoryList>
      </template>
    </SalesDetailDialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { commonUtil, customerUtil, currencyUtil, storageUtil } from '@/util'

import { saleStatusHistory } from '@/config'

import detail from './detail'
import headers from './headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'

import { ShipDialog, SalesDetailDialog } from '@/components/layouts/Dialogs'
import mutationTypes from '@/store/mutationTypes'
import { NormalButton } from '@/components/items'

export default {
  components: {
    HistoryBaseDesign,
    HistoryList,
    InputFormNew,
    ShipDialog,
    SalesDetailDialog,
    NormalButton
  },
  data: () => {
    return {
      pageTitle: 'common.common_ship-sale-history',
      pagerKey: 'salesHistory',

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 2,
        contentsCols: 12 - 2,
        inputItemHeight: '32px'
      },

      searchDetail: detail.detail,

      headers: headers.headers,
      tableKey: headers.tableKey,
      productListHeaders: headers.productListHeaders,

      searchHeaderInfo: {
        productName: '',
        InvalidData: true,
        checkboxLabel: 'sale.sale_not-show-invalid-sales'
      },
      searchDetailInfo: {
        line1: {
          customerName: [],
          saleDate: { start: '', end: '' },
          completionDate: { start: '', end: '' },
          paymentDay: { start: '', end: '' },
          shipDate: { start: '', end: '' }
        },
        line2: {
          paymentStatus: {},
          shipStatus: {},
          saleStatus: {
            value: saleStatusHistory.COMPLETE_STATUS.BEFORE_COMPLETE,
            label: saleStatusHistory.STATUS_HISTORY_LABEL.BEFORE_COMPLETE
          },
          createUser: {}
        },
        line3: {
          currency: { label: '', value: null },
          amountRange: {
            min: null,
            max: null
          },
          saleInfo: {
            saleNumber: '',
            remittanceNumber: ''
          },
          ecSaleInfo: {
            saleNumber: ''
          },
          productInfo: {
            number: '',
            category: ''
          },
          productName: ''
        },
        line4: {
          saleNotificationStatus: {}
        }
      },

      summary: {},
      historyList: [],
      customerList: [],

      dialogs: {
        ship: {
          dialog: false,
          rowItems: {},
          pageInfoData: {},
          dialogReload: 0
        },
        salesDetail: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        }
      }
    }
  },
  async created() {
    this.initPager()
    this.ini()
  },
  methods: {
    ...mapGetters('User', ['isSalonAccount', 'isMakerAccount']),
    ...mapActions('Sale', ['getSaleListFromApi']),
    ...mapGetters('Sale', [
      'getSaleListFromState',
      'getMetaAndSummaryFromState',
      'getBulkOperationCompletedFromState'
    ]),
    ...mapActions('Common', ['setIsLoading']),
    ...mapMutations('UI', [
      mutationTypes.UI_SET_PAGE,
      mutationTypes.UI_SET_PAGE_COUNT
    ]),

    dialogReload(propertyName) {
      this.dialogs[propertyName].dialogReload = this.dialogs[propertyName]
        .dialogReload
        ? 0
        : 1
    },

    async ini() {
      this.setIsLoading(true)
      customerUtil.getCustomer() // CU01_顧客一覧取得
      storageUtil.getStorageIdNameList()

      const getList = await this.getHistoryFromApi()
      const isNoData = !Object.keys(getList).length

      const [meta, summary] = this.getMetaAndSummaryFromState()
      if (!this.authority.isOutsideStaff) {
        this.summary = {
          totalRows: isNoData ? 0 : meta.totalRows,
          totalAmount: isNoData ? 0 : summary.totalAmount.amount,
          currencyId: isNoData ? '' : summary.totalAmount.currencyId,
          unitName: isNoData
            ? ''
            : currencyUtil.findCurrencyNameById(summary.totalAmount.currencyId)
                .unitName,
          currencyAmount: isNoData ? {} : summary.currencyAmount,
          matchedProductTotalAmount: isNoData
            ? {}
            : summary.matchedProductTotalAmount,
          matchedProducts: isNoData ? [] : summary.matchedProducts,
          matchedUnitName:
            isNoData || summary.matchedProducts.length === 0
              ? ''
              : currencyUtil.findCurrencyNameById(
                  summary.matchedProductTotalAmount.currencyId
                ).unitName
        }
      } else {
        this.summary = {}
      }

      this.historyList = isNoData
        ? []
        : getList
            .sort((a, b) => {
              const keyName = 'saleId'
              if (a[keyName] > b[keyName]) return -1
              if (a[keyName] < b[keyName]) return 1
              return 0
            })
            .map((ele, Index) => {
              ele.panelIndex = Index + 1
              ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
              return ele
            })
      this.setIsLoading(false)
    },

    formatObjectRequest(val) {
      return this.isObject(val) ? val.value : val
    },
    async getHistoryFromApi() {
      const line1 = this.searchDetailInfo.line1
      const line2 = this.searchDetailInfo.line2
      const line3 = this.searchDetailInfo.line3
      const line4 = this.searchDetailInfo.line4

      // Status
      const paymentStatus = this.getPaymentStatusSearchValue(
        line2.paymentStatus
      )
      const shipStatus = this.getShipStatusSearchValue(line2.shipStatus)
      const saleStatus = this.getSaleStatusSearchValue(line2.saleStatus)

      // API call
      const ret = await this.getSaleListFromApi({
        invalidSaleDisplay: this.searchHeaderInfo.InvalidData ? 0 : 1,

        // saleDate
        saleStartDate: commonUtil.nullEmptyFormatNull(line1.saleDate.start),
        saleEndDate: commonUtil.nullEmptyFormatNull(line1.saleDate.end),
        // completionDate
        completedStartDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.start
        ),
        completedEndDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.end
        ),
        // paymentDate
        paymentStartDate: commonUtil.nullEmptyFormatNull(
          line1.paymentDay.start
        ),
        paymentEndDate: commonUtil.nullEmptyFormatNull(line1.paymentDay.end),
        // shipDate
        shipStartDate: commonUtil.nullEmptyFormatNull(line1.shipDate.start),
        shipEndDate: commonUtil.nullEmptyFormatNull(line1.shipDate.end),

        salePaymentStatusId: commonUtil.nullEmptyFormatNull(paymentStatus),
        shipStatusId: commonUtil.nullEmptyFormatNull(shipStatus),
        saleStatusId: commonUtil.nullEmptyFormatNull(saleStatus),
        saleNotificationStatusId: commonUtil.nullEmptyFormatNull(
          line4.saleNotificationStatus
            ? line4.saleNotificationStatus.value
            : null
        ),
        userId: commonUtil.nullEmptyFormatNull(
          this.formatObjectRequest(line2.createUser)
        ),

        customerIds: commonUtil.nullEmptyFormatNull(
          line1.customerName
            .map((customerName) => {
              return customerName.value
            })
            .join(',')
        ),
        currencyId: commonUtil.nullEmptyFormatNull(
          this.formatObjectRequest(line3.currency)
        ),
        priceMin: commonUtil.nullEmptyFormatNull(line3.amountRange.min),
        priceMax: commonUtil.nullEmptyFormatNull(line3.amountRange.max),
        searchKey: commonUtil.nullEmptyFormatNull(line3.saleInfo.saleNumber),
        remittanceNumber: commonUtil.nullEmptyFormatNull(
          line3.saleInfo.remittanceNumber
        ),
        exOrderNumber: commonUtil.nullEmptyFormatNull(
          line3.ecSaleInfo.saleNumber
        ),
        productNumber: commonUtil.nullEmptyFormatNull(line3.productInfo.number),
        productCategoryId: commonUtil.nullEmptyFormatNull(
          line3.productInfo.category
        ),
        productName: commonUtil.nullEmptyFormatNull(
          this.searchHeaderInfo.productName
        ),
        matchedProductName: commonUtil.nullEmptyFormatNull(line3.productName),
        page: commonUtil.nullEmptyFormatNull(this.pageInfo[this.pagerKey].page)
      })

      const getList = this.getSaleListFromState()

      // 履歴の一括選択チェックボックスを解除する
      if (this.$refs.historyListComponent) {
        this.$refs.historyListComponent.changeAllCheckBox(false)
        this.$refs.historyListComponent.allChangeCheckBox = false
      }

      return getList
    },
    isObject(val) {
      return val && typeof val === 'object'
    },
    getPaymentStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.PAYMENT_STATUS
      switch (status.value) {
        case statusList.BEFORE_PAYMENT: {
          return 1
        }
        case statusList.AFTER_PAYMENT: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getShipStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.SHIP_STATUS
      switch (status.value) {
        case statusList.BEFORE_SHIP: {
          return 1
        }
        case statusList.AFTER_SHIP: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getSaleStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.COMPLETE_STATUS
      switch (status.value) {
        case statusList.BEFORE_COMPLETE: {
          return 1
        }
        case statusList.AFTER_COMPLETE: {
          return 2
        }
        case statusList.CANCEL: {
          return 3
        }
        default: {
          return null
        }
      }
    },

    getBeforeCompleteFlgTmp(rec) {
      return rec.status == 1 && !rec.compDate
    },

    rowDialogMethodCommon(...args) {
      const [dialogName, info] = args

      switch (dialogName) {
        case 'reload': {
          this.ini()
          break
        }
        default:
          this.rowDialogMethodShip(dialogName, ...info)
      }
    },
    rowDialogMethodCommonDataSet(type, rowItems, pageInfoData) {
      const dataInfo = this.dialogs[type]
      dataInfo.rowItems = rowItems
      dataInfo.pageInfoData = pageInfoData
      dataInfo.dialog = true
    },
    rowDialogMethodShip(type, ...args) {
      const [rowItems, pageInfoData] = args
      this.rowDialogMethodCommonDataSet(type, rowItems, pageInfoData)
    },

    completeShip() {
      this.ini()
      this.dialogs.ship.dialog = false
    },
    completesalesDetail() {
      this.ini()
      this.dialogs.salesDetail.dialog = false
    },
    initPager() {
      this[mutationTypes.UI_SET_PAGE]({ index: 1, key: this.pagerKey })
      this[mutationTypes.UI_SET_PAGE_COUNT]({ length: 1, key: this.pagerKey })
    },
    offSearchHeaderInfoInvalidData() {
      this.searchHeaderInfo.InvalidData = false
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    ...mapGetters('UI', ['pageInfo']),
    bulkOperationCompleted() {
      return this.getBulkOperationCompletedFromState()
    }
  },
  watch: {
    searchDetailInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.ini()
      }
    },
    bulkOperationCompleted(val) {
      if (!val) return
      this.ini()
    }
  }
}
</script>
<style scoped lang="scss">
.inputFormStyle {
  &::v-deep {
    .MultipleSelectCustomerName {
      width: 822px;
    }
  }
}
</style>
